export const useLocalStorage = (key, initialValue) => {
  return [initialValue];
};